import styled from 'styled-components'

export const SContentWrap = styled.div`
   width: 100%;
   padding: 3vh 1vh 0 1vh;
`